

import { defineComponent, SetupContext } from "@vue/composition-api";

export default defineComponent({
  name: "MainFooter",
  setup(props: undefined, context: SetupContext) {}
});
